import { render, staticRenderFns } from "./mobfull.vue?vue&type=template&id=21c6d5ea&scoped=true"
import script from "./mobfull.vue?vue&type=script&setup=true&lang=js"
export * from "./mobfull.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mobfull.vue?vue&type=style&index=0&id=21c6d5ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6d5ea",
  null
  
)

export default component.exports